import { DateRange } from '@mui/x-date-pickers-pro';
import moment, { Moment } from 'moment/moment';
import { useEffect, useMemo, useState } from 'react';

import { useUserActivity } from '~/data/userActivity';
import { getDateRangeWithFullDays } from '~/utils/helper';

export const useEmployeeActivityLog = (employeeId: number) => {
  const { userActivity, getUserActivity } = useUserActivity();

  const defaultRequestParams = useMemo(
    () => ({
      startDate: moment().subtract(2, 'weeks').startOf('date').toDate(),
      endDate: moment().endOf('date').toDate(),
      employees: [employeeId],
    }),
    [employeeId],
  );

  const [fetchDateRange, setFetchDateRange] = useState<DateRange<Moment>>([
    moment(defaultRequestParams.startDate),
    moment(defaultRequestParams.endDate),
  ]);

  const onRangeChange = (dateRange: DateRange<Moment | null>) => {
    const newDateRange = getDateRangeWithFullDays(dateRange);
    const [startDate, endDate] = newDateRange;

    if (moment.isMoment(startDate) && moment.isMoment(endDate)) {
      setFetchDateRange(newDateRange);
      getUserActivity({
        ...defaultRequestParams,
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
      });
    }
  };

  useEffect(() => {
    getUserActivity(defaultRequestParams);
  }, [getUserActivity, defaultRequestParams]);

  return {
    userActivity: userActivity,
    onRangeChange,
    dateRange: fetchDateRange,
  };
};
